import { BehaviorSubject } from 'rxjs'
import { CurrentChannelData } from './channel-track-data'

export interface VODVideo {
  id: string
  langs?: VODLanguage[]
  metadata?: VODMetadata
  videoUrl?: string
  trailerUrl?: string
  bannerUrl?: string
  thumbnailUrl?: string
  drm: boolean
  drmConfig?: VODDRMConfig
  state?: VODState
}

export interface VODState {
  status$: BehaviorSubject<VODStatus>
  duration$: BehaviorSubject<number | undefined>
  currentTime$: BehaviorSubject<number | undefined>
  tracks$: BehaviorSubject<CurrentChannelData | undefined>
  subtitleEnabled$: BehaviorSubject<boolean>
  subtitleChange$: BehaviorSubject<SubtitleData | undefined>
}

export enum VODStatus {
  NONE = 'NONE',
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  READY = 'READY',
  PLAYING = 'PLAYING',
  PAUSED = 'PAUSED',
  COMPLETED = 'COMPLETED',
}

export interface SubtitleData {
  duration: number
  text?: string
}

export interface VODMetadata {
  certificate?: string
  creator?: string
  description?: string
  duration?: number
  genres?: string[]
  type?: string
  year?: string
}

export interface VODLanguage {
  code: string
  title?: string
  short?: string
  full?: string
  credits?: {
    actors: string[]
    directors: string[]
  }
}

export enum VODDRMType {
  WIDEVINE = 'WIDEVINE',
}

export type VODDRMConfig = WidevineConfig

export interface BaseVODDRMConfig {
  type: VODDRMType
}

export interface WidevineConfig extends BaseVODDRMConfig {
  type: VODDRMType.WIDEVINE
  widevineLicenseUrl: string
  headers?: { [key: string]: string }[]
}
